// 中文语言包
export default {
  nav: {
    home: '首頁',
    brand: '品牌',
    product: '產品',
    exclusive: '尊享·尊寵',
    cooperation: '合作',
    contact: '聯絡我們',
    bMenu: {
      understand: '了解VESCOR',
      tech: '技術與專業',
      desc1: '在阿爾卑斯山脈終年積雪的褶皺間，瑞士Cellcare實驗室的科學家們以冰川融水為靈感，解碼時間對肌膚的低語。2017年誕生的VESCOR，不僅是高端護膚品牌，更是跨越時空的美學契約。',
      desc2: 'Cellcare瑞士實驗室，世界三大純生態原料研究生產工廠之-CRB， 打造了革命性的護膚科技。'
    },
    pMenu: {
      allProducts: '所有產品',

      mask: '面膜',
      elastic: '彈力賦活系列',
      essence: '賦顏菁萃系列',

      mask1: '膠原蛋白蜜肌面膜',
      mask2: '黑鑽至臻炭煥顏面膜',

      elastic1: '彈力賦活精華水',
      elastic2: '彈力賦活抗皺精華液',
      elastic3: '彈力賦活抗皺精華霜',

      essence1: '賦顏菁萃精華油',
      essence2: '柔光水潤粉底液'
    },
  },
  footer: {
    copyright: '- VESCOR ©‌ 2025 -'
  },
  home: {
    story: {
      title1: '起源於阿爾卑斯的自然奇蹟',
      title2: '自然與時間的對話',
      desc1: '在瑞士蘇黎世的靜謐山谷中，千年冰川流轉見證了自然的力量與時間的雕刻。正是在這片孕育生命奇蹟的土地上，Cellcare瑞士實驗室誕生於科學與自然的交會點。',
      desc2: '2017年，實驗室創立了VESCOR—',
      desc3: '一個專注於探索肌膚年輕密碼的高端護膚品牌，為追求卓越護膚體驗的現代女性，開啟肌膚青春永駐的全新篇章。',
      more: 'Know More About VESCOR STORY...'
    },
    tech: {
      title1: '科技與專業',
      title2: '瑞士科研保障',
      desc1: 'Cellcare瑞士實驗室憑藉瑞士聯邦衛生局認證與歐盟GMP標準，將科學研究實力與匠心工藝融為一體。',
      desc2: 'Cellcare瑞士實驗室，持瑞士聯邦衛生局認證及歐盟GMP標準，融合科學實力與匠心工藝。嚴選阿爾卑斯山溫泉純水及歐洲有機原料，攜手美寶麗Mibelle集團與CRB工廠，打造革命性護膚科技。基因抗糖化技術，精準阻斷糖化，重塑肌膚彈性與光澤，定義瑞式奢寵美學。',
      more: 'Know More About VESCOR STORY...'
    },
    features: {
      feature1: {
        title: '基因抗醣化技術',
        desc: '標靶修復糖化部位，阻止膠原蛋白老化，重塑肌膚彈性與年輕光澤。'
      },
      feature2: {
        title: '植物奈米精萃',
        desc: '超微分子直達肌膚深層，瞬間滲透，清爽滋潤。'
      },
      feature3: {
        title: '高效無壓護膚理念',
        desc: '精簡精準，塗抹即見效，讓肌膚保養與修護回歸自然與高效的模式，真正實現科學美膚。'
      }
    },
    product: {
      title1: '"美麗不僅屬於肌膚，更屬於優雅生活本身。"',
      title2: 'Schönheit gehört nicht nur zur Haut, sondern auch zum eleganten',
      title3: '正是VESCOR堅定不移的信仰',
      philosophy1: '"美力覺醒・時光無懼"',
      philosophy2: '是VESCOR始終堅持的哲學理念。',
      philosophyDesc1: '在繁忙的都市生活中，VESCOR不僅是一種護膚選擇，更是一種生活方式',
      philosophyDesc2: '——平衡、從容、優雅。',
      philosophyDesc3: '在每一个「美力覺醒」的瞬间，',
      philosophyDesc4: '破译「時光無懼」的永恒密钥。',
      more: 'Know More About VESCOR STORY...',
      productMore: '了解詳情...',
      descriptions: {
        product1: '彈力賦活精華水',
        product1Desc: '「VESCOR魔法1+1」，抗氧化第一步<br>開啟醣化狙擊戰。',
        product2: '彈力賦活抗皺精華液',
        product2Desc: '「VESCOR魔法1+1」，深層滲透，彈力活化<br>抗氧+抗醣雙重功效。 ',
        product3: '彈力賦活抗皺精華霜',
        product3Desc: '「VESCOR魔法1+1」，定格裸感美肌<br/>鎖鮮防護，持久保濕。',
        product4: '膠原蛋白蜜肌面膜',
        product4Desc: '富含的膠原蛋白，是肌膚保持年輕的祕密。',
        product5: '黑鑽至臻炭煥顏面膜',
        product5Desc: '備長炭的奇妙加持，讓肌膚喝飽水。',
        product6: '賦顏菁萃精華油',
        product6Desc: '角鯊烷以油養膚，解鎖凍齡肌密',
        product7: '柔光水潤粉底液',
        product7Desc: '山茶籽油的神奇力量，輕鬆打造自然裸妝。',
      }
    },
  },
  join: {
    title1: 'Join',
    title2: 'VESCOR致力於為內外兼修的現代女性打造',
    title3: '奢寵保養體驗計劃',
    desc1: '我們一起，追求自然與科學的平衡，關注肌膚內外健康，同時無懼時間流轉，堅定探索自我。',
    desc2: '無論是在職場中自信應對挑戰，或是在生活中優雅淡然，VESCOR始終與她們相伴，賦予她們從容與美麗。',
    more: '了解詳情...'
  },
  brand: {
    title1: '起源於阿爾卑斯的自然奇蹟',
    subtitle1: 'A Dialogue Between Nature and Time',
    subtitle2: '“美力覺醒・時光無懼”',
    subtitle3: '是 VESCOR 始終堅持的哲學理念。',
    subtitle4: '“瑞士奢寵護膚體驗”',
    subtitle5: '專為內外兼修的現代女性打造',
    content1: '在瑞士蘇黎世的靜謐山谷中，千年冰川流轉見證了自然的力量與時間的雕刻。<br />正是在這片孕育生命奇蹟的土地上，Cellcare瑞士實驗室誕生於科學與自然的交會點。<br />2017 年，實驗室創立了 VESCOR—<br />一個專注於探索肌膚年輕密碼的高端護膚品牌，<br />為追求卓越護膚體驗的現代女性，開啟肌膚青春永駐的全新篇章。',
    content2: '使用 VESCOR 護膚品的每一刻，都是與自然與時間的親密對話。<br /><br />當細膩的產品輕觸肌膚，猶如阿爾卑斯山的清風拂面。<br />瑞士阿爾卑斯山泉純水與天然植物精華深度融合，為肌膚注入源源不斷的生命力。<br /><br />獨創的「基因抗糖化技術」精準修復歲月痕跡，重塑肌膚彈性與光澤，讓時間的腳步在此停駐。',
    content3: '在繁忙的都市生活中，VESCOR 不僅是一種護膚選擇，更是一種生活方式<br />—— 平衡、從容、優雅。<br />在每一個「美力覺醒」的瞬間，<br />破譯「時光無懼」的永恆密鑰。',
    content4: '在 VESCOR，我們堅信美麗是自然與科學的和諧共生，是內外健康的完美統一。在時光流轉中，也依然能夠堅定地探索自我，綻放獨特光彩。<br />選擇 VESCOR，與時間共舞，演繹永恆之美。',
    moreDetails: '了解',
    luxuryPlan: '“VESCOR奢寵保養體驗計劃”',
    moreText: '詳情...',
    newGroupTitle1: '體驗更多',
    newGroupTitle2: 'VESCOR的秘密...',
    newGroupContent: '阻止膠原蛋白老化，<br />重塑肌膚彈性 <br />年輕光澤。',
    rightTitle1: '瑞士科學研究保障',
    rightText1: '將科研實力與匠心工藝融為一體。',
    rightTitle2: '瑞式奢寵產品系列',
    rightText2: '讓你的肌膚"體驗阿爾卑斯"'
  },
  tech: {
    // 科技与专业部分
    techProfessional: {
      title1: '科技與專業',
      subtitle1: '瑞士科研保障，開啟護膚新境界',
      content1: '深度融合世界領先的科研實力與匠心工藝，憑藉瑞士聯邦衛生局的權威認證與歐盟GMP標準的嚴格把控，為每一款產品築牢科學與安全的基石。',
      subtitle2: '科學與安全的雙重承諾',
      content2: 'Cellcare 實驗室嚴格遵循瑞士聯邦衛生局的認證標準，<br />確保從研發到生產的每一個環節都符合最高規格的質量要求。',
      subtitle3: '「基因抗醣化素（肌肽）」',
      subtitle4: 'GENE ANTI-IMMOLATION',
      content3: '防止肌膚膠原蛋白酶化，使真皮層增生膠原蛋白，鞏固真皮組織<br />使膚觸飽滿有活力。<br />外在抗氧化，內在抗醣化，告別衰老鬆弛的皮膚。'
    },
    // 全球顶尖技术合作部分
    globalCooperation: {
      title1: '“全球頂尖技術合作”',
      subtitle1: '創新與卓越的泉源',
      mibelleTitle: '「美寶麗Mibelle集團」',
      mibelleContent: '作為全球知名的植物活性成分供應商，美寶麗集團以其持續的研發投入和科技創新聞名於世，為VESCOR的護膚產品賦予了獨特的抗衰老和修復功能。',
      crbTitle: '「CRB工廠」',
      crbContent: '作為全球領先的純生態原料研究生產工廠之一，CRB專注於利用全球最佳的植物和自然成分，開發高效且安全的護膚原料，確保了高度的純淨性和卓越的修復效果。'
    },
    // 天然精粹部分
    naturalExtract: {
      title1: '“天然精粹”',
      subtitle1: '阿爾卑斯山溫泉水與有機植物原料',
      content1: '采用瑞士瓦萊州冰川自湧泉，經過多重淨化和礦物質調配，能夠有效滋養肌膚，保濕滲透效率較常規溫泉水提升240%。<br />結合歐洲有機土地種植的優質植物原料，幫助肌膚恢復活力，煥發青春光彩。'
    },
    // 科研与匠心工艺部分
    researchCraftsmanship: {
      title1: '“科研與匠心工藝的完美結合”',
      subtitle1: '創新與傳承的融合。',
      content1: 'VESCOR的護膚系列不僅注重科學研發，更將匠心工藝融入其中。<br />我們致力於將現代科技與自然成分完美融合，創造出革命性的護膚科技。<br /><br />從原料篩選到配方研發，從生產流程到質地優化，每一個環節都體現了對科學的尊重與對美學的追求。'
    },
    // 其他内容部分
    otherContent: {
      title1: '“瑞士細胞級抗衰科技 | 賦能內外兼修的當代菁英肌”',
      subtitle1: '創新與卓越的泉源',
      content1: '當都市霓虹侵蝕肌膚防禦屏障，當跨時區差旅打破細胞修護節<br />律，當多重角色壓力加速膠原流失。',
      content2: 'VESCOR以瑞士Cellcare實驗室37年研究成果，構建「三維生物護城河」，<br />為現代女性的肌膚築起智慧防線。',
      subtitle2: '「全球權威品質認證體系」',
      content3: '瑞士聯邦藥品監督管理局（SWISSMEDIC）A級認證生產體系。',
      content4: '欧盟EMA药用级GMP标准原料筛选系统。'
    },
    // 尖端生物传导系统部分
    bioDelivery: {
      title1: '“尖端生物傳導系統”',
      subtitle1: '多層靶向遞送科技',
      content1: '搭載美寶麗集團專利脂質體包裹工藝，通過雙親性載體精准輸送<br />阿爾卑斯雪絨花活性成分，經瑞士SGS實驗室檢測顯示，<br />28天表皮層鎖水密度呈現顯著性改善。',
      subtitle2: '生態屏障修護體系',
      content2: '採用CRB工廠超臨界CO2梯度萃取科技，完整保留金盞花黃酮與<br />積雪草苷活性分子群，通過人體功效測試驗證具有加速表皮修護行程的作用。'
    },
    // 生态矩阵部分
    alpineMatrix: {
      title1: '“阿爾卑斯生態矩陣”',
      subtitle1: '2000公尺冰川活性水。',
      content1: '採用瑞士瓦萊州冰川自湧泉，經磁共振納米化處理，<br />形成直徑1.8nm的「六角水分子簇」，<br /><br />實驗室資料顯示保濕滲透效率較常規溫泉水提升240%。',
      title2: '“有機植物能量庫”',
      subtitle2: '與歐盟Ecocert認證農場合作培育',
      content2: '√晝夜溫差18℃環境生長的山地玫瑰。<br /><br />√紫外線指數8+區域馴化的高山火絨草。<br /><br />√經3代育種優化的藥用級積雪草。'
    },
    // 品牌理念部分
    brandPhilosophy: {
      title1: '「VESCOR 不止創造護膚品，更構建肌膚的「生物節律算法」',
      content1: '每一次護理，都是細胞與科技的優雅共振。我們以雪絨花般純粹的守護，讓肌膚與靈魂同步新生。',
      title2: '「真正的奢侈，是讓時光成為加持而非對手」',
      content2: '——VESCOR 瑞式美學，獻給每一個在時光長河中優雅綻放真我風采的妳。'
    }
  },
  productPage: {
    mainTitle: '親愛的美膚探索者',
    mainContent: '你是否期待一場由肌膚煥新開啟的人生蛻變？<br />不僅收穫透亮光澤的年輕肌，更成為万千女性的护肤领航者？<br />VESCOR奢寵保養體驗計畫邀你共赴這場集自我重塑與價值實現的雙重盛宴，<br/>與時間共舞，演繹永恆之美。',
    step1Title: 'Step-1 加入 VESCOR 奢寵保養體驗計劃第 1 步',
    step1Subtitle: '體驗卓越，開啟肌膚煥新之門',
    step1Content: '當你選擇 VESCOR，一場專屬的肌膚煥新之旅就此開啟。<br />你只需每天在家投入 30 分鐘，遵循簡單的護膚流程，<br/>就能親身感受肌膚由內而外的煥發。<br /><br />清潔肌膚：使用溫和的潔面產品，徹底清潔面部。<br /><br />彈力賦活精華水：取適量 VESCOR 精華水，輕拍至吸收，為肌膚打底。<br /><br />彈力賦活抗皺精華液：滴 2-3 滴 VESCOR 精華液於掌心，均勻塗抹於面部與頸部。<br /><br />彈力賦活抗皺面霜：取豌豆大小的 VESCOR 面霜，輕柔按摩至完全吸收。<br /><br />賦顏菁萃精華油：滴 2-3 滴精華油於掌心，輕柔按摩至完全吸收，為肌膚上鎖。<br /><br />VESCOR 面膜（每週 2-3 次）：一片 VESCOR 面膜，享受 15-20 分鐘的奢華護理。<br /><br />持續一個月使用 VESCOR 系列產品，你的肌膚將綻放出前所未有的光彩<br/> —— 細膩、緊緻、光澤。<br/>每一瓶產品的開啟都是與奢寵的約定，<br/>每一次塗抹都在續寫肌膚的煥新詩篇。',
    step2Title: 'Step-2 加入 VESCOR 奢寵保養體驗計劃第 2 步',
    step2Subtitle: '分享魅力，成就奢寵形象官身份',
    step2Content: '在體驗 VESCOR 奢寵保養的魅力後，我們鼓勵你將這份美好的體驗分享給身邊的人，讓更多人感受到 VESCOR 帶來的肌膚奇蹟。<br /><br />憑藉你的熱情和影響力，你將有機會晉升為 VESCOR 奢寵形象官，獲得更多的專屬權益福利與資源。<br /><br />作為 VESCOR 品牌的奢寵形象官，你將引領更多與你一樣內外兼修的現代女性走向美麗與自信，幫助更多人實現肌膚的煥新與美麗蛻變。讓梳妝鏡前的自信，化為千萬女性眼中的星光。',
    step3Title: 'Step-3共創美好，攜手邁向美麗新境界',
    step3Subtitle: '共創美好，攜手邁向美麗新境界',
    step3Content: 'VESCOR 奢寵保養體驗計畫不僅是一個保養方案，更是一個充滿機會與可能的平台。<br /><br />在這裡，你將與眾多同樣熱愛保養、追求美麗的夥伴們攜手共進，共同成長。而 VESCOR，將為你提供持續的支持，幫助你在美麗之路上持續前進。<br /><br />加入 VESCOR 奢寵保養體驗計劃，從肌膚煥新到身份成就，從個人分享到引領他人，讓我們一起邁向美麗新境界，書寫屬於你的美麗傳奇。讓你的每一次呵護，都成為肌膚與心靈的優雅共振。',
    joinButton: '加入 <span class="highlight">“VESCOR奢寵保養體驗計劃”</span>',
    highlight: 'VESCOR奢寵保養體驗計劃',
    newSectionTitle: '<span>體驗更多</span><br />VESCOR的秘密...',
    newSectionContent: '阻止膠原蛋白老化，<br />重塑肌膚彈性 <br />年輕光澤。',
    techPageTitle: '瑞士科學研究保障',
    techPageContent: '將科研實力與匠心工藝融為一體。',
    productCatalogTitle: '瑞式奢寵產品系列',
    productCatalogContent: '讓你的肌膚"體驗阿爾卑斯"',
    comingSoon: '即将开放'
  },
  productDetail7: {
    title: 'VESCOR柔光水潤粉底液',
    subTitle: '肌膚的隱形守護者',
    description: {
      para1: '在都市的喧囂中，你的肌膚需要一位守護者，一位能夠抵禦外界侵害、提供全天候保護的隱形夥伴。',
      para2: 'VESCOR柔光水潤粉底液，源自瑞士的高階抗衰产品，<br>獨特的山茶（CAMELLIA JAPONICA）籽油成分，成為你肌膚的隱形守護者。',
      para3: '輕鬆打造自然裸妝，<br>讓你的肌膚來自然、健康、充滿活力。<br>不假面，不厚重，巨持久，讓你的美麗全天候在線。',
      usageTitle: '使用方法',
      usageContent: '·每日早晨使用；<br>·在清潔肌膚並護膚管理後，取適量 VESCOR 柔光水潤粉底液於掌心；<br>·用指腹或化妝海綿將粉底液均勻塗抹於面部與頸部；<br>·避開眼周肌膚，輕拍面部幫助粉底液更好地貼合肌膚，打造自然裸妝效果。<br><br>·為延長妝容持久度，可搭配輕薄的定妝粉或噴霧；<br>·請搭配紫外線防護產品，以維持肌膚的年輕光彩。'
    },
    consultationButton: '中國大區（含港澳&大陸地區）訂單諮詢',
    qrCodeInfo: {
      text1: '您可以通过微信扫码登录<span>VESCOR官方小程序</span>',
      text2: '或查找关注<span>VESCOR品牌官方微信公众号</span>',
      text3: '咨询相关服务信息'
    },
    detailItems: [
      {
        subTitle: '山茶籽油精粹',
        subDescription: '大自然的神奇力量',
        detailList: [
          {
            subTitle: '高親膚性',
            subDescription: '富含類人體皮脂膜油酸，長效鎖水保濕，讓肌肉膚時保持水潤光澤。'
          },
          {
            subTitle: '抗氧化',
            subDescription: '角鯊烯成分，抵禦光老化，減少皺紋，延緩衰老，讓肌膚煥發年輕活力。'
          },
          {
            subTitle: '提亮膚色',
            subDescription: '茶多酚抑制黑色素活性，淡化色素，讓肌膚自然透亮。'
          }
        ]
      },
      {
        subTitle: '内外兼修',
        subDescription: '肌膚自由呼吸',
        detailList: [
          {
            subTitle: '對外保護',
            subDescription: '隔絕粉塵氧化，保護肌膚免受外界侵害。'
          },
          {
            subTitle: '對內透氣',
            subDescription: '隔絕粉壓，讓肌膚自由呼吸，保持清透無瑕。'
          }
        ]
      },
      {
        subTitle: '持久守護',
        subDescription: '打造全天候的美麗',
        detailList: [
          {
            subTitle: '智慧反射技術',
            subDescription: '高效能遮瑕，均勻膚色，提昇亮度，讓你在任何光線下都能展現自然光澤。'
          },
          {
            subTitle: '24小時持久',
            subDescription: '天然油脂24小時長效持妝，溫和穩定，不論是辦公室還是夜晚派對，你的妝容都能持久如新。'
          }
        ]
      }
    ]
  },
  productDetail6: {
    title: 'VESCOR 賦顏菁萃精華油',
    subTitle: '在肌膚上把鎖',
    description: {
      para1: '如果您的肌膚擁有一把神奇的鎖，能夠抵禦外界的侵襲，鎖住青春的秘密， 你猜會是什麼？',
      para2: '這把鎖，就是VESCOR賦顏菁萃精華油中天然成分－角鯊烷。',
      usageTitle: '使用方法',
      usageContent: '·每日早晚使用。<br>·於清潔肌膚及使用精華水後，取 2-3 滴精華油於掌心；<br>·輕柔按摩於面部與頸部，避開眼周肌膚。<br><br>·角鯊烷成分在肌膚表層形成天然保護膜，鎖住水分，抵禦外界刺激；<br>·早晨使用後請搭配紫外線防護產品，以保護肌膚免受外界侵害。'
    },
    consultationButton: '中國大區（含港澳&大陸地區）訂單諮詢',
    qrCodeInfo: {
      text1: '您可以通过微信扫码登录<span>VESCOR官方小程序</span>',
      text2: '或查找关注<span>VESCOR品牌官方微信公众号</span>',
      text3: '咨询相关服务信息'
    },
    detailItems: [
      {
        subTitle: '角鲨烷',
        subDescription: '大自然的滋潤禮物',
        detailTitle: "天然的“保护层”皮脂膜",
        detailDescription:
          "角鲨烷，这个与人体皮脂中的角鲨烯几乎一模一样的成分，能够在您的肌肤表层形成一层天然的“保护层”皮脂膜。它像一位智慧的向导，帮助您的肌肤抵御外界的刺激，锁住水分，让您的肌肤时刻保持滋润。",
      },
      {
        subTitle: '以油養膚',
        subDescription: '平衡護膚的藝術',
        detailTitle: "你的第二层肌肤，<br/>这不仅仅是一个口号",
        detailDescription:
          "VESCOR赋颜菁萃精华油，以油养肤，让肌肤润弹充盈，焕发自然光泽。它不仅能够提亮肤色、减少皱纹、修复受损肌肤屏障，还能快速补水、紧致肌肤、改善肌肤光滑度。",
      }
    ],
    groupLayout: {
      title: '瑞士原材料 “液体黄金”植萃力量',
      items: [
        [
          {
            subTitle: "提亮肌膚",
            subDescription: "讓肌膚煥發光彩。",
          },
          {
            subTitle: "快速補水",
            subDescription: "讓肌膚水嫩動人",
          }
        ],
        [
          {
            subTitle: "減少皺紋",
            subDescription: "撫平歲月的痕跡",
          },
          {
            subTitle: "緊緻肌膚",
            subDescription: "塑造緊緻輪廓",
          }
        ],
        [
          {
            subTitle: "修補受損肌膚",
            subDescription: "重建肌膚的防禦牆",
          },
          {
            subTitle: "改善肌膚光滑",
            subDescription: "讓肌膚如絲般滑順",
          }
        ]
      ]
    }
  },
  productDetail5: {
    title: '彈力賦活抗皺精華霜',
    subTitle: '營養封存艙',
    description: {
      para1: '定格裸感美肌',
      usageTitle: '使用方法',
      usageContent: '·每日早晚使用；<br>·於清潔肌膚及使用精華水和精華液後，取適量精華霜（約豌豆大小）於掌心；<br>·均勻塗抹於面部與頸部，輕柔按摩至完全吸收。<br><br>·將抗老成分牢牢鎖住，在肌膚表面形成透氣鎖水層；<br>·搭配 VESCOR 精華水和精華液使用，效果更佳；<br>·早晨使用後請搭配紫外線防護產品，以保護肌膚免受外界侵害。'
    },
    consultationButton: '中國大區（含港澳&大陸地區）訂單諮詢',
    qrCodeInfo: {
      text1: '您可以通过微信扫码登录<span>VESCOR官方小程序</span>',
      text2: '或查找关注<span>VESCOR品牌官方微信公众号</span>',
      text3: '咨询相关服务信息'
    },
    detailItems: [
      {
        subTitle: '鎖鮮防護',
        subDescription: '潤澤收官',
        detailTitle: '',
        detailDescription: '慕斯質地輕盈包裹，將抗老成分牢牢鎖住，在肌膚表面形成透氣鎖水層。'
      },
      {
        subTitle: '持久保濕',
        subDescription: '提升妝效',
        detailTitle: '',
        detailDescription: '72小時長效保濕，晨起肌膚如剝殼荔枝般水潤嫩滑，妝前使用更可提升底妝貼合度200%。'
      }
    ]
  },
  productDetail4: {
    title: '彈力賦活抗皺精華液',
    subTitle: '雙抗主戰場',
    description: {
      para1: '活化膠原蛋白新生',
      para2: '深層滲透，彈性活化',
      para3: '5D微囊精華直達肌底，精準釋放抗氧成分，清除自由基，阻斷膠原損傷。',
      usageTitle: '使用方法',
      usageContent: '·每日早晚使用；<br>·於清潔肌膚後，取適量精華液（約 1-2 泵）於化妝棉或掌心；<br>·輕柔拍打或擦拭於面部與頸部，直至完全吸收。<br><br>·香桃木葉萃取物增強肌膚防禦力，延緩衰老；<br>·基因抗糖化素（肌肽）防止膠原蛋白糖化；<br>·搭配 VESCOR 精華水和面霜使用，效果更佳。'
    },
    consultationButton: '中國大區（含港澳&大陸地區）訂單諮詢',
    qrCodeInfo: {
      text1: '您可以通过微信扫码登录<span>VESCOR官方小程序</span>',
      text2: '或查找关注<span>VESCOR品牌官方微信公众号</span>',
      text3: '咨询相关服务信息'
    },
    detailItems: [
      {
          subTitle: '抗氧+',
          subDescription: '抗糖雙重功效',
          detailTitle: '生育酚與抗壞血酸協同作用',
          detailDescription: '清除自由基，促進膠原蛋白合成，肌膚緊緻有彈性。<br/><br/>樹莓萃取物蘊含豐富微量元素，加速肌膚新陳代謝，煥發活力。香桃木葉萃取物增強肌膚防禦力，延緩衰老，肌膚更年輕。基因抗糖化素（肌肽）防止膠原蛋白糖化，鞏固真皮組織，肌膚飽滿有活力。'
        },
        {
          subTitle: '魔法加成',
          subDescription: '',
          detailTitle: '觸膚瞬間吸收，清爽不黏膩，肌膚全天候保持透亮呼吸感。',
          detailDescription: ''
        }
    ]
  },
  productDetail3: {
    title: '彈力賦活精華水',
    subTitle: '抗氧化第一步',
    description: {
      para1: '開啟糖化狙擊戰',
      usageTitle: '使用方法',
      usageContent: '·每日早晚使用；<br>·於清潔肌膚後，取適量精華水（約 3-4 泵）於化妝棉或掌心；<br>·輕柔拍打或擦拭於面部與頸部，直至完全吸收。<br><br>·基因抗糖化素（肌肽）防止膠原蛋白糖化；<br>·微酸質地溫和軟化角質層，為後續護膚步驟打開通道；<br>·搭配 VESCOR 精華液和面霜使用，效果更佳。'
    },
    consultationButton: '中國大區（含港澳&大陸地區）訂單諮詢',
    qrCodeInfo: {
      text1: '您可以通过微信扫码登录<span>VESCOR官方小程序</span>',
      text2: '或查找关注<span>VESCOR品牌官方微信公众号</span>',
      text3: '咨询相关服务信息'
    },
    detailItems: [
      {
        subTitle: '先導淨化',
        subDescription: '平衡打底',
        detailTitle: '微酸質地溫和軟化角質層，<br/>為後續護膚步驟開啟通道。',
        detailDescription: ''
      },
      {
        subTitle: '抗氧雙星',
        subDescription: '抗糖複合物',
        detailTitle: '生育酚與抗壞血酸協同作用',
        detailDescription: '清除自由基，促進膠原蛋白合成，肌膚緊緻有彈性。樹莓萃取物蘊含豐富微量元素，加速肌膚新陳代謝，煥發活力。<br/><br/>香桃木葉萃取物增強肌膚防禦力，延緩衰老，肌膚更年輕。基因抗糖化素（肌肽）防止膠原蛋白糖化，鞏固真皮組織，肌膚飽滿有活力。'
      },
      {
        subTitle: '魔法加成',
        subDescription: '',
        detailTitle: '輕拍3秒，喚醒肌膚吸收力，<br/>為後續精華吸收奠定基礎。',
        detailDescription: ''
      }
    ]
  },
  productDetail2: {
    title: 'VESCOR黑鑽至臻炭煥顏面膜',
    subTitle: '揭開肌膚煥新的秘密',
    description: {
      para1: '備長炭的神奇力量，打造黑鑽魔力，喚醒沉睡美肌',
      para2: '神奇材質－備長炭。炭不僅柔軟貼膚，還有無數微小孔洞，能夠像磁鐵一樣吸附走肌膚深層的污垢和多餘油脂。每一次使用，都是對肌膚的一次深層淨化。',
      usageTitle: '使用方法',
      usageContent: '·每週 2-3 次；<br>·於清潔肌膚後，取出一片面膜，敷於面部，避開眼周和唇部；<br>·靜待 15-20 分鐘，取下面膜後，輕柔按摩剩餘精華至完全吸收。<br><br>·備長炭深層淨化，水潤力量深層滋養；<br>·明星舒緩成分舒緩肌膚，促進修復，高活性多肽因數幫助肌膚恢復年輕活力；<br>·搭配 VESCOR 彈力賦活系列產品使用，效果更佳。'
    },
    consultationButton: '中國大區（含港澳&大陸地區）訂單諮詢',
    qrCodeInfo: {
      text1: '您可以通过微信扫码登录<span>VESCOR官方小程序</span>',
      text2: '或查找关注<span>VESCOR品牌官方微信公众号</span>',
      text3: '咨询相关服务信息'
    },
    detailItems: [
      {
        subTitle: '水潤力量',
        subDescription: '深層滋養',
        detailTitle: '肌膚渴望水分？',
        detailDescription: 'VESCOR面膜含有高水分保濕配方，能深層補水，讓肌膚如同喝飽了水的植物，從內而外散發水潤光澤。<br/><br/>玻尿酸精華的加入，更是讓肌膚的水潤UP UP，細膩光滑，彈性十足。<br/><br/>膠原蛋白不僅能保濕，還能緊緻肌膚，減少鬆弛，讓輪廓更加清晰，重現緊緻有彈性的年輕狀態。<br/><br/>同時，它還能增強肌膚的自我修復能力，修復受損的肌膚屏障，讓肌膚更健康、更有抵抗力。'
      },
      {
        subTitle: '明星舒緩成分',
        subDescription: '肌膚的溫柔守護',
        detailTitle: '肌膚的溫柔守護者',
        detailDescription: '我們精心挑選了積雪草、虎杖根、黃芩根和迷迭香葉萃取物等明星舒緩成分，它們是肌膚的溫柔守護者。<br/><br/>幫助舒緩肌膚，促進修復，讓肌膚在享受深層清潔的同時，也能感受到溫柔的呵護。'
      },
      {
        subTitle: '高活多肽因數',
        subDescription: '抗衰老的秘密武器',
        detailTitle: '抗衰老的秘密武器',
        detailDescription: '隨著年齡的增長，肌膚的自我修復能力逐漸減弱。 <br/><br/>VESCOR面膜中的多肽修護因數，就是您抗衰老的秘密武器。它能促進細胞代謝再生，幫助肌膚恢復年輕活力，讓肌膚告別暗沉，迎接明亮。'
      }
    ]
  },
  productDetail1: {
    title: 'VESCOR 膠原蛋白蜜肌面膜',
    subTitle: '給肌膚的瑞士甜蜜假期',
    description: {
      para1: '肌膚悄悄對你說："我要去瑞士！"',
      para2: '當肌膚也需要一個假期，VESCOR膠原蛋白蜜肌面膜就是它的頭等艙機票。飛往瑞士，享受一場奢華的肌膚SPA，只需20分鐘，肌膚就能說："我回來了，更年輕了！"',
      para3: '20分鐘瑞士之旅，肌膚煥然一新！',
      para4: '每一次敷上，都是沉浸式的奢華SPA，每一滴精華都是大自然的饋贈，每一分鐘都是肌膚的蛻變。 20分鐘，不只是時間的流逝，更是肌膚從疲憊到煥然一新的華麗轉身。VESCOR讓每一次呵護都成為肌膚的盛宴，讓每一次「旅行」都讓你的肌膚更年輕、更動人！',
      usageTitle: '使用方法',
      usageContent: '·每週 2-3 次；<br>·於清潔肌膚後，取出一片面膜，敷於面部，避開眼周和唇部；<br>·靜待 15-20 分鐘，取下面膜後，輕柔按摩剩餘精華至完全吸收。<br><br>·膠原蛋白的水潤力量深層滋養；<br>·積雪草、紫松果菊等植物精華舒緩肌膚，促進修復；<br>·搭配 VESCOR 彈力賦活系列產品使用，效果更佳。'
    },
    consultationButton: '中國大區（含港澳&大陸地區）訂單諮詢',
    qrCodeInfo: {
      text1: '您可以通过微信扫码登录<span>VESCOR官方小程序</span>',
      text2: '或查找关注<span>VESCOR品牌官方微信公众号</span>',
      text3: '咨询相关服务信息'
    },
    detailItems: [
      [
        {
          subTitle: '膠原蛋白',
          subDescription: '肌膚的青春源泉',
          detailTitle: '面膜中富含的膠原蛋白，<br/>是肌膚保持年輕的秘密',
          detailDescription: '它深入肌膚底層，活化細胞活力，讓肌膚恢復彈性，重現18歲的光彩。<br/><br/> 膠原蛋白不僅能保濕，還能緊緻肌膚，減少鬆弛，讓輪廓更加清晰，重現緊緻有彈性的年輕狀態。<br/><br/> 同時，它還能增強肌膚的自我修復能力，修復受損的肌膚屏障，讓肌膚更健康、更有抵抗力。'
        },
        {
          subTitle: '水潤力量',
          subDescription: '肌膚的瀑布',
          detailTitle: 'VESCOR面膜帶著瑞士山泉的<br/>清新，為肌膚一場水潤的瀑布浴',
          detailDescription: '玻尿酸精華讓肌膚喝飽水，光滑得像剝了殼的雞蛋。玻尿酸能夠鎖住水分，形成保濕屏障，讓肌膚敷完面膜後仍能維持24小時的水潤狀態。<br/><br/>我們也特別添加了瑞士冰川水，富含天然礦物質和微量元素，為肌膚帶來深層滋養，讓肌膚從內而外煥發光彩。'
        },
        {
          subTitle: '植物精華',
          subDescription: '肌膚的溫柔鄉',
          detailTitle: '積雪草、紫松果菊等植物精華，<br>是肌膚的溫柔守護者',
          detailDescription: '它們輕聲細語地撫慰肌膚，讓肌膚在享受清潔的同時，也能感受到溫柔的擁抱。 <br/><br/>這些植物精華具有天然的舒緩功效，能够緩解肌膚的敏感和不適，讓敏感肌也能安心使用。<br/><br/>積雪草被譽為“天然修復劑”，能够促進膠原蛋白合成，修復受損的肌膚細胞，讓肌膚恢復健康狀態。'
        }
      ],
      [
        {
          subTitle: '360°貼合',
          subDescription: '完美貼合每吋肌膚',
          detailTitle: '面膜設計完美貼合臉部輪廓',
          detailDescription: '確保每一滴精華都能被肌膚完全吸收，不浪費一滴。採用先進的超薄面膜紙技術，厚度僅為傳統面膜的1/3，輕薄到幾乎讓人忘卻它的存在。<br/><br/>敷上瞬間，彷彿為肌膚披上了一層透明的保護膜，透氣又服帖，讓你在享受滋養的同時，也能自由呼吸。因為超薄，所以比較貼合；因為貼合，所以更有效率。'
        },
        {
          subTitle: '天然香氛',
          subDescription: '沉浸式瑞士之旅',
          detailTitle: '打開面膜的那一刻，彷彿置身於瑞士的阿爾卑斯山腳下',
          detailDescription: '我們特別調配了天然植物香氛，融合了瑞士松樹的清新、阿爾卑斯草甸的芬芳和一絲薄荷的清涼，讓你在敷面膜的20分鐘裡，彷彿真的在瑞士度假，身心得到徹底放鬆。'
        }
      ]
    ]
  },
  cooperation: {
    mainTitle: '品質，穿越週期的船票<br />VESCOR以敬畏之心，雕琢每一寸肌膚的期待。',
    paragraphs: {
      txt1: '從瑞士阿爾卑斯山的原料秘境，到精密儀器屏息的實驗室，自然與科技在瓶中共鳴。這不僅是一場護膚革命，更是肌膚煥新的哲學實踐。',
      txt2: '科學，看得見的魔法<br />我們解碼時光在肌膚上的痕跡，將複雜分子式轉化為觸手可及的改變。尖端科技喚醒沉睡細胞，讓細紋、暗沉、鬆弛的焦慮，在鏡中化為驚嘆。',
      txt3: '品牌，無聲的承諾<br />櫥窗流轉的光澤，是千萬消費者託付的信任。我們搭建的不是貨架，而是連結品質生活方式的橋樑，讓每個合作端口都成為高端美膚體驗的燈塔。',
      txt4: '共贏，篤定的答案<br />合作夥伴的成長曲線，是品牌的生命線。從物流到終端服務，從視覺到體驗設計，VESCOR構建的是一個共生共榮的生態圈。',
      txt5: '此刻，我們向全球發出邀約——選擇VESCOR，與前沿科技同行，引領高端護膚潮流。美力覺醒・時光無懼，帶著對美業的赤誠，與我們共譜市場傳奇。'
    },
    consultationSection: {
      title: '中國地區（香港澳門&大陸地區）合作詳情諮詢',
      subtitle: 'China (Hong Kong, Macau & Mainland China) cooperation details c',
      comingSoon: '即将开放'
    }
  },
  contact: {
    mainTitle: 'VESCOR.亚洲业务合作業務合作',
    subTitle: '瑞士悦享荟健康医疗（香港）科技有限公司',
    businessCenter: '亞洲業務管理中心',
    hongkongAddress: '<span>香港辦公室</span> <br /><br />中國，香港<br />尖沙咀柯士甸路7-9號<br />煥利商業大樓<br />7樓63室',
    email: 'vescorchina@vescorskincar.com',
    comingSoon: '即将开放',
    consultationItems: [
      {
        title: '中國地區（香港澳門&大陸地區）合作詳情諮詢',
        subtitle: 'China (Hong Kong, Macau & Mainland China) cooperation details consultation'
      },
      {
        title: '亞洲地區合作詳情諮詢',
        subtitle: 'Asia cooperation details consultation'
      },
      {
        title: 'North America cooperation details consultation',
        subtitle: 'Marketing and sales cooperation'
      }
    ]
  },
  productCatalog: {
    title: '瑞式奢寵產品系列',
    subtitle: '讓你的肌膚"體驗阿爾卑斯"',
    allProducts: '所有產品',
    masks: '面膜',
    elasticSeries: '彈力賦活系列',
    essenceSeries: '賦顏菁萃系列',
    checkDetails: '查看详情',
    products: {
      softMoistFoundation: {
        name: '柔光水潤粉底液',
        desc: '山茶籽油精粹,大自然的神奇力量<br/>肌膚的隱形守護者'
      },
      collagenMask: {
        name: '膠原蛋白蜜肌面膜',
        desc: '給肌膚的瑞士甜蜜假期<br/>一次20分鐘瑞士之旅，让肌膚煥然一新！'
      },
      blackDiamondMask: {
        name: '黑鑽至臻炭煥顏面膜',
        desc: '備長炭的神奇力量<br/>黑鑽魔力，喚醒沉睡美肌'
      },
      resilienceWater: {
        name: '彈力賦活精華水',
        desc: '开启糖化狙击战'
      },
      resilienceSerum: {
        name: '彈力賦活抗皺精華液',
        desc: '深層滲透，彈性活化<br/>抗氧+抗糖雙重功效'
      },
      resilienceCream: {
        name: '彈力賦活抗皺精華霜',
        desc: '定格裸感美肌<br/>鎖鮮防護，持久保濕'
      },
      rejuvenatingOil: {
        name: '賦顏菁萃精華油',
        desc: '肌膚的天然「保護膜」－角鯊烷<br/>抵禦外界的侵襲，鎖住青春'
      }
    }
  },
}